import axiosInstance from "../config/axiosConfig";

export const LicenseService = {
  activate: async (code: string) =>
    axiosInstance.post<void>('api/license/activate', null, { params: { code } }),
};
